jQuery(document).ready(function($) {

    // Uniquement sur desktop : sous 640px, .process_images est masqué
    let mm = gsap.matchMedia()

    mm.add("(min-width: 640px)", function() {

        $( ".bloc_process" ).each(function() {

            let bloc = this
            let paras = bloc.querySelectorAll(".liste_process .process")
            let figures = bloc.querySelectorAll(".process_images .process_img")

            if (!paras.length || !figures.length) return

            // États initiaux : tout masqué (découpe collée à droite), sauf la 1re
            gsap.set(figures, { clipPath: "inset(0 0 0 100%)" })
            gsap.set(figures[0], { clipPath: "inset(0 0 0 0%)", zIndex: 1 })

            let current = 0
            let ztop = 1

            // Active la photo d'index i : révélation clip-path droite → gauche
            function activate(i) {
                if (i === current || !figures[i]) return
                current = i
                gsap.set(figures[i], { zIndex: ++ztop, clipPath: "inset(0 0 0 100%)" })
                gsap.to(figures[i], {
                    clipPath: "inset(0 0 0 0%)",
                    duration: 0.9,
                    ease: "power3.out",
                    overwrite: true
                })
            }

            // Un ScrollTrigger par paragraphe : actif quand il traverse le centre
            paras.forEach(function(para, i) {
                scrollTrigger.create({
                    trigger: para,
                    start: "top center",
                    end: "bottom center",
                    onToggle: function(self) {
                        if (self.isActive) activate(i)
                    }
                })
            })

        })

    })

});
